import { createFileRoute } from '@tanstack/react-router'
import { ActionItemsPage } from '@/pages/action-items'

export const Route = createFileRoute('/_authenticated/projects/action-items')({
  staticData: { title: 'Action Items' },
  component: ActionItemsPage,
})
